import { DisabledPrompt } from "@bcm-dev/bcms-vite";
import { TableBody, TableColumnContainer, TableColumnView, TableItemContainer, TableView, WidgetContainer, WidgetView } from "components/shared";
import { PrimaryButton } from "components/ui";
import React from "react";
import { SVGAsset } from "res";
import "./styles.css";

/**
 * @function AppsAwaitingAuthWidget
 * @return {React.Component}
 * @exported true
 * @description Shows the apps awaiting authorization
 */

export default function AppsAwaitingAuthWidget(props) {
  return(
    <WidgetContainer className="apps-waiting-auth-widget">
      <WidgetView text="Apps Awaiting Authorization">
        <TableView>
          <TableColumnContainer>
            <TableColumnView 
              className="text-left" 
              text={<>
                <span>Nickname</span>
                <DisabledPrompt>
                  <SVGAsset id='ArrowUpIcon' className='clickable' />
                </DisabledPrompt>
                </>} />
            <TableColumnView 
              className="text-left" 
              text={<>
                <span>Last Accessed</span>
                <DisabledPrompt>
                  <SVGAsset id='SortIcon' className='clickable' />
                </DisabledPrompt>
                </>} />
          </TableColumnContainer>
          <TableBody>
            <TableItemContainer>
              <td colSpan="2" className="text-center table-item-text-view no-apps-text">No apps are awaiting authorization</td>
            </TableItemContainer>
          </TableBody>
        </TableView>
        <DisabledPrompt><PrimaryButton text="Authorize" className="disabled" /></DisabledPrompt>
      </WidgetView>
    </WidgetContainer>
  );
}